import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { siteConfig } from "@/lib/siteConfig";

const CalendlyCtx = createContext({ openCalendly: () => {} });

export function CalendlyProvider({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <CalendlyCtx.Provider value={{ openCalendly: () => setOpen(true) }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent
          data-testid="calendly-modal"
          className="max-w-3xl w-[95vw] p-0 bg-[#0a0a0a] border border-white/10 overflow-hidden rounded-none sm:rounded-lg"
        >
          <DialogHeader className="px-6 pt-6 pb-4 border-b border-white/10">
            <DialogTitle className="font-display text-lg tracking-tight text-white uppercase">
              Book A Strategy Call
            </DialogTitle>
            <DialogDescription className="sr-only">
              Schedule a strategy call with DULORME LABS using the embedded booking calendar below.
            </DialogDescription>
          </DialogHeader>
          <div className="h-[70vh] w-full bg-white">
            <iframe
              title="Book a strategy call"
              src={siteConfig.calendlyUrl}
              className="w-full h-full border-0"
              data-testid="calendly-iframe"
            />
          </div>
        </DialogContent>
      </Dialog>
    </CalendlyCtx.Provider>
  );
}

export const useCalendly = () => useContext(CalendlyCtx);
